import React, { Suspense, useEffect, useState, createContext, useMemo, useCallback } from "react";
import "./assets/css/loader.css";
import { useNavigate } from "react-router-dom";
import { setCultures } from "./redux/common/cultureSlice";
import { setRefreshToken, setResourceKey, setUserCurrency } from "./services/common";
import { setCultureSession, getSessionExpiry } from "./services/common";
import { Routes, Route } from "react-router-dom";
import { getSportsSearchParams } from "./redux/sports/sportsSearch";
import { getSportsDetails } from "./redux/sports/sportsDetails";
import { useDispatch, useSelector } from "react-redux";
import { getFlightSearchParams, setFlightSearchData } from "./redux/flight/flightSearch";
import { currencyActions, getCurrencyinfo } from "./redux/commonSlice";
import { getCountryInfo } from "./redux/common/countrySlice";
import { getSelectedFlightData } from "./redux/flight/flightSelectedSlice";
import { getSportsSeatData } from "./redux/sports/sportsPayment";
import { getTicketData } from "./redux/ticketSlice";
import { useSearchParams } from "react-router-dom";
import { getLoginDetails, getUserData } from "./redux/loginSlice";
import { newSearchReq } from "./services/flight/searchServices";
import SeoPageThree from "./components/seo/SeoPageThree";
import moment from "moment";
import { getCouponCodeData } from "./redux/flight/couponCodeSlice";
import { getSelectedSportsData } from "./redux/sports/selectedSportsSlice";
import { getSelectedAncillaries } from "./redux/flight/getSelectedAncillaryDetails";

const EnTheme = React.lazy(() => import("./EnTheme"));
const ArTheme = React.lazy(() => import("./ArTheme"));
const Header = React.lazy(() => import("./components/common/header"));
const Footer = React.lazy(() => import("./components/common/footer"));
const Home = React.lazy(() => import("./components/home"));
const FlightResult = React.lazy(() => import("./components/flight/flight_result/flight_result"));
const WegoSearch = React.lazy(() => import("./components/flight/wego/WegoSearch"));
const WegoBrandedFare = React.lazy(() => import("./components/flight/wego/WegoBrandedFare"));
const FlightPax = React.lazy(() => import("./components/flight/flight_pax/flight_pax"));
const SportsResult = React.lazy(() => import("./components/sports/sports_result/sports_result"));
const SportsDetails = React.lazy(() => import("./components/sports/sports_details/sports_details"));
const SportsPax = React.lazy(() => import("./components/sports/sports_pax/sports_pax"));
const PaymentProgress = React.lazy(() => import("./components/flight/flightPayment/payment_progress"));
const PaymentFailed = React.lazy(() => import("./components/flight/flightPayment/payment_failed"));
const BookingFailed = React.lazy(() => import("./components/flight/flightPayment/bookingFailed"));
const SportsTicket = React.lazy(() => import("./components/Ticket/sports_ticket"));
const ManageMyBooking = React.lazy(() => import("./components/mybooking/ManageBooking"));
const MyProfile = React.lazy(() => import("./components/mybooking/MyProfile/MyProfile"));
const MyBookingAccount = React.lazy(() => import("./components/mybooking/MyBookingAccount"));
const MyBookingWithoutLogin = React.lazy(() => import("./components/mybooking/ReffLogin/MyBookingWithoutLogin"));
const MyBookingCancel = React.lazy(() => import("./components/mybooking/Common/MyBookingCancel"));
const ResetPassword = React.lazy(() => import("./components/common/ResetPassword"));
const FLightBookingOnly = React.lazy(() => import("./components/flight/flightPayment/flight_booking_only"));
const TicketBooked = React.lazy(() => import("./components/flight/flightPayment/ticketBooked"));
const FlightTicket = React.lazy(() => import("./components/FlightTicket"));
const CMSPages = React.lazy(() => import("./components/common/CMSPages"));
const SpecialOfferDetails = React.lazy(() => import("./components/specialoffer/SpecialOfferDetails"));
const DirectPayment = React.lazy(() => import("./components/common/DirectPayment"));
const DirectPaymentSuccess = React.lazy(() => import("./components/common/DirectPaymentSuccess"));
const Unauthorized = React.lazy(() => import("./components/common/Unauthorized"));
const SeoAllAirline = React.lazy(() => import("./components/seo/SeoAllAirline"));
const SeoSelectedAirline = React.lazy(() => import("./components/seo/SeoSelectedAirline"));

const url_segment = process.env.REACT_APP_BASE_URL.replace("/", "");
let current_url = "";
if (url_segment !== "")
  current_url = window.location.href.replace(url_segment, "");
else
  current_url = window.location.href;

const PageLoader = () => (
  <div className="openLoader">
    <div className="loader-lg">
      <div className="loader-open-dot"></div>
      <div className="loader-open-dot"></div>
      <div className="loader-open-dot"></div>
      <div className="loader-open-dot"></div>
      <div className="loader-open-dot"></div>
      <div className="loader-open-dot"></div>
    </div>
  </div>
);

export const outsideContext = createContext();

function Paths() {
  // ✅ ALL hooks at the top - before any returns
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoadAr, setIsLoadAr] = useState(false);
  const [currencyMenuOpen, setCurrencyMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [mobMenuOpen, setMobMenuOpen] = useState(false);
  const [menuTab, setMenuTab] = useState("flightSearch");

  const culture = useSelector((state) => state.culture.currentCulture);
  const currency = useSelector((state) => state.currencyDetails.currentCurrency);
  const currencyCountry = useSelector((state) => state.currencyDetails.currencyCountry);
  const flightSearchStatus = useSelector((state) => state.flightSearch.loading);
  const flightSearchData = useSelector((state) => state.flightSearch.flightSearch);
  const sportsSearchStatus = useSelector((state) => state.sportsSearch.loading);
  const sportsDetailsStatus = useSelector((state) => state.sportsDetails.loading);
  const selectedFlightStatus = useSelector((state) => state.selectedFlight.loading);
  const countrySearchStatus = useSelector((state) => state.countryDetails.loading);
  const loginDetails = useSelector((state) => state.loginDetail.loginDetail);
  const userData = useSelector((state) => state.loginDetail.userData);
  const sportsSeatStatus = useSelector((state) => state.sportsPayment.loading);
  const ticketDataStatus = useSelector((state) => state.ticketData.loading);
  const cultureStatus = useSelector((state) => state.culture.loading);

  const [searchQueryParams] = useSearchParams();
  const currentSearchID = searchQueryParams.get("SearchId");

  const isReviewPage = useMemo(
    () => current_url.split("/")[5]?.split("?")[0] === "FlightReview",
    []
  );

  const setMenuTabHandler = useCallback((params) => {
    setMenuTab(params);
  }, []);

  // ✅ Fix 1: useOutsideAlerter as plain function - NO hooks inside
  function useOutsideAlerter(ref1, ref2, type, funct, module = "") {
    function handleClickOutside(event) {
      if (type === "pax" || type === "sort") {
        if (ref1.current && !ref1.current.contains(event.target)) {
          funct(false);
          return;
        }
      }
      if (type === "baggagePopup") {
        funct(false);
      }
      if (type === "wallet" || type === "country") {
        if (ref1.current && !ref1.current.contains(event.target)) {
          funct(false);
          return;
        }
      }
      if (module === "currencyAndProfile") {
        if (ref1.current && !ref1.current.contains(event.target)) {
          setCurrencyMenuOpen(false);
        }
        if (ref2?.current && !ref2?.current.contains(event.target)) {
          setProfileOpen(false);
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }

  // ✅ Fix 2: useMemo BEFORE any early returns
  const contextValue = useMemo(
    () => ({ useOutsideAlerter, mobMenuOpen, setMobMenuOpen }),
    [mobMenuOpen]
  );

  const urlPage = current_url.split("/")[4]?.split("?")[0];

  // ✅ All useEffects before early returns
  useEffect(() => {
    moment.locale(culture);
    sessionStorage.setItem("culture", culture);
  }, [culture]);

  useEffect(() => {
    let refreshTokenTimeOut;

    async function fetch() {
      try {
        let lang;
        const urlPart = current_url.split("/")[3];
        if (urlPart === "en") lang = "en";
        else if (urlPart === "ar") lang = "ar";
        else lang = process.env.REACT_APP_CULTURE;

        const [resource, cultureSessionResponse] = await Promise.all([
          setResourceKey(),
          setCultureSession({ lang }),
        ]);

        if (resource && cultureSessionResponse) {
          const { data } = cultureSessionResponse;
          dispatch(setCultures(data));
          const LOCAL_STORAGE_KEYS = { en: "languageen", ar: "languagear" };
          localStorage.setItem(
            LOCAL_STORAGE_KEYS[data.culture],
            JSON.stringify(cultureSessionResponse.data.lang)
          );
          document.title = data.lang.tathkarah_title;
          if (data.culture === "ar") setIsLoadAr(true);
        }

        dispatch(getCountryInfo());
        dispatch(getCurrencyinfo());
        dispatch(getLoginDetails());
        dispatch(getUserData());

      } catch (error) {
        console.error("Error occurred while setting culture session:", error);
      }

      const urlPage5 = current_url.split("/")[5]?.split("?")[0];

      if (urlPage5 === "MyBooking" || urlPage === "MyBooking") {
        dispatch(getTicketData(navigate));
      }
      if (urlPage === "SportsResult") {
        dispatch(getSportsSearchParams(navigate));
      }
      if (urlPage === "SportsDetails") {
        dispatch(getSportsSearchParams(navigate));
        dispatch(getSportsDetails(navigate));
      }
      if (
        urlPage === "FlightResult" ||
        current_url?.split?.("/")?.[4]?.split?.("?")?.[0] === "WegoBrandedFare"
      ) {
        dispatch(getFlightSearchParams(currentSearchID, navigate));
      }
      if (current_url.split(/[/?]/)[4] === "Flight") {
        dispatch(getFlightSearchParams(currentSearchID, navigate));
        dispatch(getSelectedFlightData(currentSearchID, navigate));
        dispatch(getCouponCodeData(currentSearchID, navigate));
        dispatch(getSelectedAncillaries(currentSearchID, navigate));
      }
      if (urlPage === "Sports") {
        dispatch(getCountryInfo(navigate));
        dispatch(getSportsDetails(navigate));
        dispatch(getSportsSeatData(navigate));
        dispatch(getSportsSearchParams(navigate));
        dispatch(getSelectedSportsData(currentSearchID, navigate));
        dispatch(getCouponCodeData(navigate));
      }
      if (urlPage === "SportsTicket" || urlPage === "FlightTicket") {
        dispatch(getTicketData(navigate));
      }
    }

    async function initRefreshSession(loadAll = true) {
      const tokenExpiryResponce = await getSessionExpiry();
      if (tokenExpiryResponce) {
        refreshTokenTimeOut = setTimeout(async () => {
          const responce = await setRefreshToken();
          if (responce) initRefreshSession(false);
        }, tokenExpiryResponce);
        if (loadAll) fetch();
      }
    }

    initRefreshSession();
    return () => clearTimeout(refreshTokenTimeOut);
  }, []);

  useEffect(() => {
    if (loginDetails?.Role === "Admin" && userData?.AgencyCurrency) {
      (async () => {
        const responce = await setUserCurrency(
          userData?.AgencyCurrency,
          currencyCountry,
          "path"
        );
        if (responce) {
          dispatch(
            currencyActions.setCurrency({
              currencyCode: userData?.AgencyCurrency,
              currencyCountry,
            })
          );
        }
      })();
    }
  }, [userData, loginDetails]);

  // ✅ Early returns AFTER all hooks
  if (
    (flightSearchStatus && urlPage === "FlightResult") ||
    (current_url.split(/[/?]/)[4] === "Flight" && selectedFlightStatus) ||
    (!flightSearchStatus && flightSearchData === "" && urlPage === "FlightResult")
  ) {
    if (!flightSearchStatus && flightSearchData === "") {
      const searchUrl = window.location.href.split("FlightResult/")[1];
      newSearchReq(searchUrl, currency, dispatch, currentSearchID, currencyCountry);
    }
    setFlightSearchData();
    return <PageLoader />;
  }

  if (sportsSearchStatus && urlPage === "SportsResult") return <PageLoader />;
  if (sportsDetailsStatus && urlPage === "SportsDetails") return <PageLoader />;
  if (
    (countrySearchStatus || sportsDetailsStatus || sportsSeatStatus || sportsSearchStatus) &&
    urlPage === "SportsPaxPayment"
  ) return <PageLoader />;
  if (ticketDataStatus && (urlPage === "SportsTicket" || urlPage === "FlightTicket"))
    return <PageLoader />;
  if (cultureStatus) return <PageLoader />;

  return (
    <outsideContext.Provider value={contextValue}>
      <Suspense fallback={<PageLoader />}>
        {culture === "en" && <EnTheme />}
        {culture === "ar" && <ArTheme />}
        <div>
          <Routes>
            {culture && (
              <Route
                path="*"
                element={
                  <Header
                    setMenuTab={setMenuTabHandler}
                    showsearchPanel={menuTab}
                    useOutsideAlerter={useOutsideAlerter}
                    currencyMenuOpen={currencyMenuOpen}
                    setCurrencyMenuOpen={setCurrencyMenuOpen}
                    profileOpen={profileOpen}
                    setProfileOpen={setProfileOpen}
                  />
                }
              />
            )}
          </Routes>

          <main id="main-content">
            <Routes>
              {culture && (
                <Route
                  exact
                  path={process.env.REACT_APP_BASE_URL}
                  element={
                    <Home
                      setMenuTab={setMenuTabHandler}
                      showsearchPanel={menuTab}
                    />
                  }
                />
              )}
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture"}
                element={
                  <Home setMenuTab={setMenuTabHandler} showsearchPanel={menuTab} />
                }
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/FlightResult/:tripType/:route/:pax/:class/:isDirect/:prefAirline/:allAirport"}
                element={<FlightResult />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/MetaSearch"}
                element={<WegoSearch />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/WegoBrandedFare"}
                element={<WegoBrandedFare />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/Flight/*"}
                element={<FlightPax isReviewPage={isReviewPage} />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/SportsResult"}
                element={<SportsResult />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/SportsDetails"}
                element={<SportsDetails />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/Sports/*"}
                element={<SportsPax />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/PaymentProgress"}
                element={<PaymentProgress />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/PaymentFailed"}
                element={<PaymentFailed />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/TicketingFailed"}
                element={<BookingFailed />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/SportsTicket"}
                element={<SportsTicket />}
              />
            </Routes>

            <Routes>
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/Mybooking/ManageBooking"}
                element={<ManageMyBooking />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/MyProfile"}
                element={<MyProfile />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/MybookingForm"}
                element={<MyBookingAccount />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/MybookingForm/MyBooking"}
                element={<MyBookingWithoutLogin />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/MybookingCancelFromMail"}
                element={<MyBookingCancel />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/ChangePassword"}
                element={<ResetPassword />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/BookingFailed"}
                element={<BookingFailed />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/BookingSuccess"}
                element={<FLightBookingOnly />}
              />
              <Route
                exact
                path={process.env.REACT_APP_BASE_URL + ":culture/TicketBooked"}
                element={<TicketBooked />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/FlightTicket"}
                element={<FlightTicket />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/AboutUs"}
                element={<CMSPages />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/ContactUS"}
                element={<CMSPages />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/Terms"}
                element={<CMSPages />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/SiteMap"}
                element={<CMSPages />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/PrivacyPolicy"}
                element={<CMSPages />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/seo"}
                element={<SeoPageThree />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/SpecialOfferDetails"}
                element={<SpecialOfferDetails />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/DirectPayment"}
                element={<DirectPayment />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/DirectPayment/paymentSuccess"}
                element={<DirectPaymentSuccess />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + "/unauthorized"}
                element={<Unauthorized />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/AllAirlines"}
                element={<SeoAllAirline />}
              />
              <Route
                path={process.env.REACT_APP_BASE_URL + ":culture/AllAirlines/:airlineCode"}
                element={<SeoSelectedAirline />}
              />
            </Routes>
          </main>

          <Routes>
            {culture && <Route path="*" element={<Footer />} />}
          </Routes>
        </div>
      </Suspense>
    </outsideContext.Provider>
  );
}

export default Paths;